import { RootState } from '../store';

export const selectHiringManagerOptions = (state: RootState) => state.hiringManager.hiringManagerOptions;

export const selectHiringManagerOptionsRequestStatus = (state: RootState) =>
  state.hiringManager.hiringManagerOptionsRequestStatus;
